import AWSStorage from '@aws-amplify/storage'

const AWS_REGION = 'us-east-1'

class StorageInterface {
  set() {
    window.log(this)
  }

  get() {
    window.log(this)
  }

  unset() {
    window.log(this)
  }

  clear() {
    window.log(this)
  }

  isset() {
    window.log(this)
  }
}

class S3Storage extends StorageInterface {
  storage = null

  constructor(initializeObj) {
    super()
    // initializing
    this.storage = AWSStorage
    this.storage.configure({
      AWSS3: {
        bucket: initializeObj.bucket,
        region: initializeObj.region || AWS_REGION,
      },
    })
  }

  set(key, value) {
    return this.storage.put(key, value)
  }

  get(key) {
    return this.storage.get(key, {})
  }

  // unset(key) {}
  // clear() {}
  // isset(key) {}
}

class LocalStorage extends StorageInterface {
  storage = null

  constructor() {
    super()
    // initializing
    this.storage = localStorage
  }

  set(key, value) {
    this.storage.setItem(key, JSON.stringify(value || {}))
  }

  get(key) {
    return JSON.parse(this.storage.getItem(key)) || {}
  }

  unset(key) {
    this.storage.removeItem(key)
  }

  clear() {
    this.storage.clear()
  }

  isset(key) {
    // return this.storage.hasOwnProperty(key)
    return this.storage.getItem(key) !== null
  }
}

class SessionStorage extends StorageInterface {
  storage = null

  constructor() {
    super()
    // initializing
    this.storage = sessionStorage
  }

  set(key, value) {
    this.storage.setItem(key, value)
  }

  get(key) {
    return this.storage.getItem(key)
  }

  unset(key) {
    this.storage.removeItem(key)
  }

  clear() {
    this.storage.clear()
  }

  isset(key) {
    // return this.storage.hasOwnProperty(key)
    return this.storage.getItem(key) !== null
  }
}

class Storage {
  constructor(strategy, initializeObj = {}) {
    if (strategy === 's3') {
      return new S3Storage(initializeObj)
    }
    if (strategy === 'localStorage') {
      return new LocalStorage()
    }
    if (strategy === 'seesionStorage') {
      return new SessionStorage()
    }
  }
}

const local = new Storage('localStorage')
const session = new Storage('sessionStorage')
const vcReport = new Storage('s3', { bucket: 'vc-report', region: AWS_REGION })
const vcProfile = new Storage('s3', { bucket: 'vc-profile', region: AWS_REGION })
const residentFaceSheet = new Storage('s3', { bucket: 'resident-face-sheet', region: AWS_REGION })

export { local, session, vcReport, vcProfile, residentFaceSheet }
